import { render } from "./CardInvestment.vue?vue&type=template&id=04a4a52e"
import script from "./CardInvestment.vue?vue&type=script&lang=js"
export * from "./CardInvestment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__